import * as React from 'react';
import { Paragraph1 } from '@cian/ui-kit';

interface IMinPriceLabelProps {
  label: string;
}

export function MinPriceLabel({ label }: IMinPriceLabelProps) {
  return <Paragraph1 fontWeight="bold">{label}</Paragraph1>;
}
